export default "__VITE_ASSET__Cd1Y0Pwq__"